module.exports = __webpack_public_path__ + "img/logo-dark.cb7852f2.png";